// Module
var code = "<avatar :object=\"avatarObject\" :name=\"name\"></avatar>";
// Exports
export default code;